import React, { useState, useRef } from "react";

const BulkUploadModal = ({ isOpen, onClose, onUpload }) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const fileInputRef = useRef(null);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setSelectedFile(file);
    };

    const handleDrop = (event) => {
        event.preventDefault();
        const file = event.dataTransfer.files[0];
        setSelectedFile(file);
    };

    const handleUpload = () => {
        if (selectedFile) {
            onUpload(selectedFile);
            handleClose();
        }
    };

    const handleClose = () => {
        setSelectedFile(null);
        onClose();
    };

    return (
        isOpen && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 p-4">
                <div className="bg-white p-4 sm:p-6 md:p-8 rounded-lg shadow-lg w-full max-w-lg sm:w-2/3 md:w-1/2 lg:w-1/3 h-auto min-h-[22rem] max-h-[80vh] flex flex-col">

                    {/* Header */}
                    <h2 className="text-lg sm:text-xl font-semibold text-center mb-4">Upload Product CSV</h2>

                    {/* Sample Format Download */}
                    <div className="mb-2 text-sm text-center">
                        <span>Do you want sample format to upload? </span>
                        <a
                            href="/demofile.csv"
                            download="sample_product_upload.csv"
                            className="text-blue-600 hover:underline font-medium"
                        >
                            Download Sample
                        </a>
                    </div>

                    {/* Drag & Drop Section */}
                    <div
                        className="border-2 border-dashed border-gray-300 p-6 sm:p-8 text-center cursor-pointer flex-grow flex items-center justify-center"
                        onDrop={handleDrop}
                        onDragOver={(e) => e.preventDefault()}
                        onClick={() => fileInputRef.current.click()}
                    >
                        {selectedFile ? (
                            <p className="text-green-600">{selectedFile.name}</p>
                        ) : (
                            <p className="text-gray-500 text-sm sm:text-base">Drag & Drop CSV file here or click to upload</p>
                        )}
                        <input
                            type="file"
                            accept=".csv"
                            className="hidden"
                            ref={fileInputRef}
                            onChange={handleFileChange}
                        />
                    </div>

                    {/* Buttons */}
                    <div className="flex justify-end space-x-2 mt-6">
                        <button className="px-4 py-2 bg-gray-300 rounded-md" onClick={handleClose}>
                            Cancel
                        </button>
                        <button
                            className="px-4 py-2 bg-blue-600 text-white rounded-md disabled:opacity-50 disabled:cursor-not-allowed"
                            onClick={handleUpload}
                            disabled={!selectedFile}
                        >
                            Upload
                        </button>
                    </div>
                </div>
            </div>
        )
    );
};

export default BulkUploadModal;
